<template>
  <div class="animated fadeIn">
    <div class="row mt-3">
      <div class="col-12">
        &nbsp;
      </div>
    </div>
    <div class="row tex-center">
      <div class="col-12 text-center mt-5 pt-5">
        <img src="/static/img/bg/bg_folder_files.svg" style="width: 20%; opacity: 0.2; position: fixed; bottom: 35px; right: 10px;"/>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'RightContentGed',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/rightcontentempty.vue